import angular from 'angular';

let inject = ['$scope', '$uibModalInstance', 'SessionService','$timeout', '$state', 'cartData', 'AddressService', 'shCtrl'];

class ModalAddressController {

    constructor($scope, $uibModalInstance, SessionService,$timeout, $state, cartData, AddressService, shCtrl) {
        this.cartData = cartData;
        this.addressService = AddressService;
        this.directions = [];
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$state = $state;
        this.SessionService = SessionService;
        this.newDirection = {};
        this.showError = null;
        this.showSuccess = null;
        this.showErrorAlone = null;
        this.shCtrl = shCtrl;
    }

    $onInit() {
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }

        this.addressService.getAllDirections(userId).then(response => {

            this.directions = response.data;
            this.newDirection.ciudad = this.cartData.order.location.city.name + ', '
                + this.cartData.order.location.state.name + ' - ' + this.cartData.order.location.country.name;
            this.newDirection.ciudadId = this.cartData.order.location.city.id;
        });
    }

    saveDirection() {
        if (this.directionForm.$valid && this.newDirection.ciudadId) {
            this.savingDirection=true;
            //ADAP01-NC006_180
            /*if (this.directions.length) {
                if (!this.directions.some(val => {
                    return val.principal;
                }) && !this.newDirection.principal) {

                    this.showErrorAlone = 'Debes seleccionar una dirección como principal';
                    this.$timeout(() => {
                        this.showErrorAlone = null;
                    }, 1500);
                    return;
                }
            }*/

            if (!this.newDirection.principal) this.newDirection.principal = 0;

            let userId = '';
            try {
                userId = this.shCtrl.globals.currentUser.userId;
            }
            catch (e) {}

            this.newDirection["usuarioId"] = userId;

            this.addressService.saveDirection(this.newDirection).then((response) => {

                if (response.error) {
                    this.showErrorAlone = response.message;
                    this.$timeout(() => {
                        this.showErrorAlone = null;
                      this.savingDirection =false;
                    }, 1500);


                } else {
                    this.showSuccess = response.message;
                    this.$timeout(() => {
                        this.showSuccess = null;
                        this.savingDirection =false;
                        this.$uibModalInstance.close(response.id);
                    }, 1000);
                }

            });
        } else {
            this.directionForm.name.$setDirty();
            this.directionForm.searchLocationtext.$setDirty();
            this.directionForm.direction.$setDirty();
        }
    }

    redirectAllDirections(){
        this.$state.go('home.address');
        this.$uibModalInstance.dismiss('cancel');
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

ModalAddressController.$inject = inject;

export default ModalAddressController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/tunnel/modal-address/modal-address.controller.js
 **/